<template>
  <div>
    <el-button :disabled="disabled" @click="dialogObject=true">Прикрепить файл</el-button>
    <el-dialog title="Прикрепить файл"
               custom-class="modal-upload-file-3"
               append-to-body
               :disabled="disabled"
               :visible.sync="dialogObject">
      <el-upload
        :disabled="disabled"
        v-if="uploadValue === null"
        list-type="picture"
        :http-request="onUpload"
        class="upload-demo"
        accept="image/*"
        action="/"
        :show-file-list="false"
        drag
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Перетащите файл сюда или <em>нажмите, чтобы загрузить</em></div>
      </el-upload>
      <el-progress v-else :percentage="uploadValue"></el-progress>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogObject = false">Ok</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {v4 as uuidv4} from 'uuid';
import {uploadUrl} from "../../../../plugins/firebase";

export default {
  name: 'UploadFile',
  props: {
    fileListProps : Array,
    disabled: Boolean
  },
  data() {
    return {
      search: '',
      fileList: [],
      dialogObject: false,
      unit: '',
      uploadValue: null,
      jobs: [],
      step: 0,
      form: {
        value: '',
        unit: '',
        job: '',
      },
    };
  },
  computed: {
    filteredList() {
      return this.jobs.filter(job => {
        return job.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  watch: {
    fileListProps() {
      this.fileList = this.fileListProps;
    },
  },
  methods: {
    onUpload(e) {
      const imageData = e.file;

      const reader = new FileReader();
      reader.onload = async () => {
        try {
          const base64String = reader.result;

          this.uploadValue = 0;

          const response = await fetch(uploadUrl, {
            method: 'POST',
            headers: {
              'authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ file: base64String }),
          });

          if (!response.ok) {
            throw new Error('Ошибка загрузки файла');
          }

          const result = await response.text();
          this.uploadValue = 100;
          this.$emit('add-file', result); // предполагается, что API возвращает { url: "..." }
          this.dialogObject = false;
          this.uploadValue = null;
        } catch (error) {
          console.error(error.message);
          this.uploadValue = null;
        }
      };

      reader.readAsDataURL(imageData);
    },
    save() {
      this.$emit('add-job', {
        ...this.form,
      });
      this.close();
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.form.value = '';
      this.form.unit = '';
      this.form.job = '';

      this.step = 0;
    },
  },
};
</script>

<style lang="scss">
.upload-demo {
  margin: 0 auto;
  width: calc(100% - 20px);

  .el-upload {
    width: 100%;
  }

  .el-upload-dragger {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/UploadFile.vue